import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';

export function useSupportSalesEmail(): string | undefined {
  const { supportSalesEmail } = useAppSelector(getLocalisation);

  return supportSalesEmail;
}
